export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  fantasyName: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  cnpj: {
    value: '',
    maxlength: '19',
    required: true,
    state: null
  },
  contact: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  email: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  phoneNumber: {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  },
  cellNumber: {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  },
  type: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  condition: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  workImage: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  insurance: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  sendPhoto: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  acceptParts: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  address: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  addressNumber: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  complement: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  district: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  zipcode: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  stateID: {
    value: null,
    options: [],
    clearOption: false,
    required: true,
    state: null
  },
  cityID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  },
  hasRestriction: {
    value: null,
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/mechanicalworkshop/mechanicalworkshop-form.js